export const STATE_COLORS = {
  completed: 'bg-complete-project text-white',
  ongoing: 'bg-ongoing-project text-white',
  abandoned: 'bg-abandoned-project text-white',
  delayed: 'bg-delayed-project text-white',
  bidding: 'bg-bidding-project text-white',
  draft: 'bg-draft-project text-white',
  behind: 'bg-behind-project text-white',
};
